import { AGENT_CONFIGS } from "./agents.config";
export const AgentProductContext = {
    PLANNER: "planner"
};
export function isAgentProductContext(topic) {
    return (typeof topic === "string" &&
        Object.values(AgentProductContext).includes(topic));
}
/**
 * The known agents available in mad-sdk
 */
export const AVAILABLE_AI_AGENTS = Object.keys(AGENT_CONFIGS);
/**
 * Type guard to check if a value is a valid AgentName.
 */
export function isKnownAgent(value) {
    return typeof value === "string" && value in AGENT_CONFIGS;
}
export * from "./errors";
//# sourceMappingURL=types.js.map